import { useState } from "react";
import { ISystemSupplierDescriptionDialog } from "./SystemSupplierDescriptionDialog";

export function useSystemSupplierDescriptionDialogHooks(props: ISystemSupplierDescriptionDialog) {
    const [description, setDescription] = useState(props.description);

    return { description, setDescription };
}
